import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { clearErrors, getOrderDetails } from '../../actions/orderAction';
import { emptyCart } from '../../actions/cartAction';
import { Box, CircularProgress, Container, Fade, Typography, Alert } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const OrderStatus = () => {	

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const params = useParams();

    const { shippingInfo, cartItems } = useSelector((state) => state.cart);

	const theme = useTheme();
    const { loading, order, error } = useSelector((state) => state.orderDetails);

    const totalPrice = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);

    useEffect(() => {
        if (order && (order.paymentInfo?.status === 'paid' || order.paymentInfo?.status === 'pending')) {
            enqueueSnackbar("Order Placed", { variant: "success" });
            dispatch(emptyCart());
            navigate("/orders/success");
        } else if (order && order.paymentInfo?.status === 'failed') {
            enqueueSnackbar("Payment Failed", { variant: "error" });
            navigate("/orders/failed");
        }
        // eslint-disable-next-line
    }, [order])

    useEffect(() => {
        if (error) {
            enqueueSnackbar(error, { variant: "error" });
            dispatch(clearErrors());
        }
        dispatch(getOrderDetails(params.id));
    }, [dispatch, error, params.id, enqueueSnackbar]);

    return (
        <Container maxWidth="md" sx={{ mt: 8, textAlign: 'center' }}>
            <Fade in={!loading}>
                <Box>
                    {loading ? (
                        <CircularProgress color="primary" />
                    ) : error ? (
                        <Alert severity="error">
                            {error}
                        </Alert>
                    ) : order && (order.paymentInfo?.status === 'paid' || order.paymentInfo?.status === 'pending') ? (
                        <Typography variant="h6" color="success.main">
                            Order Placed Successfully!
                        </Typography>
                    ) : order && order.paymentInfo?.status === 'failed' ? (
                        <Typography variant="h6" color="error.main">
                            Payment Failed!
                        </Typography>
                    ) : (
                        <Typography variant="h6" color="warning.main">
                            Processing Order... Please wait.
                        </Typography>
                    )}
                </Box>
            </Fade>
        </Container>
    );
};

export default OrderStatus;
